import { router, useFocusEffect } from "expo-router";
import { useCallback } from "react";
import { View } from "react-native";

/**
 * Retired in the v2 student rebuild. The old standalone page is gone —
 * its surface lives elsewhere now (header overlays, program workspace
 * tabs, or the find-competition flow). Anyone hitting this URL gets
 * bounced to the dashboard.
 */
export default function RetiredStudentRouteRedirect() {
  useFocusEffect(
    useCallback(() => {
      router.replace("/student");
    }, [])
  );
  return <View />;
}
